// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.CreateEncounterRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateEncounterRequest extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	employeeId!: number | null;

	@GandalfValidator({ notNull: { message: 'End Time is required' } })
	@GandalfProperty({ designType: Date, isRequired: true })
	endDate!: Date;

	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

	@GandalfValidator({ sizeString: { message: 'Desc. cannot be longer than 4000 characters', minLength: 0, maxLength: 4000 } })
	@GandalfProperty({ designType: String })
	patientReason!: string | null;

	@GandalfValidator({ notNull: { message: 'Location is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	practiceLocationId!: number;

	@GandalfProperty({ designType: Number })
	providerId!: number | null;

	@GandalfValidator({ notNull: { message: 'Start Time is required' } })
	@GandalfProperty({ designType: Date, isRequired: true })
	startDate!: Date;

	@GandalfProperty({ designType: Number })
	subTypeId!: number | null;

	@GandalfValidator({ notNull: { message: 'Type is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	templateId!: number;

}
